<template>
    <div>
        <!-- new ticket-->
        <div v-if="true" style="padding: 16px; background-color: #EAE6E1">
            <div style="max-width: 700px; margin: auto;">

                <!-- title -->
                <div style="background:white; margin-bottom: 16px; border-radius: 5px">

                    <img style="width:100%; border-radius: 5px 5px 0px 0px"
                         src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Femail_tq.PNG?alt=media&token=33a0dafb-26aa-4646-8264-1a239a6d6604"/>

                    <div style="padding: 16px;  font-size: 20px">

                        <div >
                            Hello David,
                        </div>
                        <div style="margin-top: 4px">
                            Thank you for purchase entry ticket to
                            "<b>Travel Quest Around The World</b>"
                        </div>

                    </div>

                </div>

                <!-- Join quest-->
                <div style="background:white; margin-bottom: 16px; border-radius: 5px" >

                    <!-- title -->
                    <div style="padding: 8px; font-size: 24px; background: #885ead; color:white; border-radius: 5px 5px 0 0 ">
                        <b>Join Quest</b>
                    </div>

                    <!-- body -->
                    <div style="padding: 16px;">

                        <div >
                            - Go to <a href="TravelQuest.xyz">TravelQuest.xyz</a> and enter the next quest entry code: <b style="background: yellow">44662211</b>
                        </div>

                        <div style="margin: 8px 0px; text-transform: uppercase;">
                            <b>or</b>
                        </div>

                        <div >
                            - click the next <a href="google"> link </a>
                        </div>


                    </div>

                </div>

                <!-- creator message -->
                <div style="background:white; margin-bottom: 16px; border-radius: 5px">
                    <div style="padding: 8px; font-size: 24px; background: #885ead; color:white; border-radius: 5px 5px 0 0 ">
                        <b>Message from Quest creator </b>
                    </div>

                    <div style="padding: 16px;">
                        Hii
                        Thank you for purchasing my quest, enjoy and have fun...
                    </div>

                </div>

                <!-- support quest-->
                <div style="background:white; margin-bottom: 16px; border-radius: 5px" >

                    <!-- title -->
                    <div style="padding: 8px; font-size: 24px; background: #885ead; color:white; border-radius: 5px 5px 0 0 ">
                        <b>Support </b>
                    </div>

                    <!-- body -->
                    <div style="padding: 16px;">

                        <div style="margin-bottom: 8px;">
                            <b> For any questions please contact the quest creator</b>
                        </div>
                        <div >
                            <Div> Dan Gadasi </div>
                            <div> 050-4092457 </div>
                            <div> dan@travelAndQuest.com </div>
                        </div>

                    </div>

                </div>

                <!-- more info-->
                <div style="background:white; margin-bottom: 8px; border-radius: 5px">

                    <!--title-->
                    <div style="padding: 8px; font-size: 24px; background: #885ead; color:white; border-radius: 5px 5px 0 0 ">
                        <b>Ticket Info </b>
                    </div>

                    <!-- table -->
                    <div style="overflow-x: auto; padding: 16px">


                        <table style="border: 1px solid black;border-collapse: collapse; box-sizing: border-box; ">

                            <tr style="background: #DDDDDD">
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>ID</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Date</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Slots</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Price</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Status</td>
                            </tr>
                            <tr>
                                <td style="border: 1px solid black; padding: 4px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                                <td style="border: 1px solid black; padding: 4px;">1/1/2018 13:30*</td>
                                <td style="border: 1px solid black; padding: 4px;">10</td>
                                <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                                <td style="border: 1px solid black; padding: 4px; background: yellow">Waiting To approve</td>

                            </tr>


                        </table>

                        <div style="direction: ltr; display: inline-block;"> <b>*Timezone:</b> GMT+0200</div>
                    </div>

                </div>z

                <!-- tq info -->
                <div style="background:white; margin-bottom: 8px; padding: 8px; direction: ltr">
                    <table style="width:100%;">
                        <tr>
                            <td>
                                <div>Dan@TravelAndQuest.com</div>
                                <div>Sderot Tsahal 4, Lod, Israel</div>
                                <div>303035596</div>
                                <a href="TravelQuest.xyz">TravelQuest.xyz</a>
                            </td>
                            <td style="text-align: right">
                                <img style="width:90px; border-radius: 16px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);"
                                     src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Fapple-touch-icon-120x120.png?alt=media&token=ded9d127-7038-4b0d-8e4c-de571e6eabba"/>
                            </td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>

        <!-- receipt -->
        <div v-else style="padding: 16px; background-color: #EAE6E1">
            <div style="max-width: 600px; margin: auto;">

                <!-- top image -->
                <img style="width:100%; border-radius: 5px 5px 0 0; margin-bottom: 4px; "
                     src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Femail_tq.PNG?alt=media&token=33a0dafb-26aa-4646-8264-1a239a6d6604"/>

                <!-- receipt link -->
                <div style="background:white; margin-bottom: 8px; padding: 16px;">
                    <div style="text-align: center">
                        <div style="background: orange; font-weight: bold; font-size: 20px; padding: 8px; display:inline-block; border-radius: 5px;">
                            <a style="text-decoration: blink; color: white;" href="https://api.rivhit.co.il/pdf/FileService.svc/GetDocument/303035596/3f269c35-dcd5-4a11-8cef-b2c7e9a2179a/true/02_000001">
                                לצפייה במסמך לחץ כאן
                            </a>
                        </div>
                    </div>
                </div>

                <!-- more info-->
                <div style="background:white; margin-bottom: 8px;">

                    <!-- table -->
                    <div style="overflow-x: auto; padding: 16px">


                        <table style="border: 1px solid black;border-collapse: collapse; box-sizing: border-box; ">

                            <tr style="background: #DDDDDD">
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>ID</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Date</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Slots</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Price</td>
                                <td style='font-weight: bold;  border: 1px solid black; padding: 4px;'>Status</td>
                            </tr>
                            <tr>
                                <td style="border: 1px solid black; padding: 4px;">9b6d9389-eb35-4468-b93c-c21097a87863</td>
                                <td style="border: 1px solid black; padding: 4px;">1/1/2018 13:30*</td>
                                <td style="border: 1px solid black; padding: 4px;">10</td>
                                <td style="border: 1px solid black; padding: 8px;">10₪ </td>
                                <td style="border: 1px solid black; padding: 4px; background: green">Charged</td>

                            </tr>
                        </table>
                        <div style="direction: ltr; display: inline-block;"> <b>*Timezone:</b> GMT+0200</div>
                    </div>
                </div>

                <!-- tq info -->
                <div style="background:white; margin-bottom: 8px; padding: 8px; direction: ltr">
                    <table style="width:100%;">
                        <tr>
                            <td>
                                <div>Dan@TravelAndQuest.com</div>
                                <div>Sderot Tsahal 4, Lod, Israel</div>
                                <div>303035596</div>
                                <a href="TravelQuest.xyz">TravelQuest.xyz</a>
                            </td>
                            <td style="text-align: right">
                                <img style="width:90px; border-radius: 16px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);"
                                     src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Fapple-touch-icon-120x120.png?alt=media&token=ded9d127-7038-4b0d-8e4c-de571e6eabba"/>
                            </td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: "v_EmailBoughtTicket",
    }

</script>

<style scoped>
</style>